import React from 'react';
import { OrderFilters as OrderFiltersType, OrderStatus } from '../../../types';
import './OrderFilters.css';

interface OrderFiltersProps {
  filters: OrderFiltersType;
  onFiltersChange: (filters: OrderFiltersType) => void;
  className?: string;
}

const OrderFilters: React.FC<OrderFiltersProps> = ({ 
  filters, 
  onFiltersChange, 
  className = '' 
}) => {
  const orderStatusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'processing', label: 'Processing' },
    { value: 'ready_for_collection', label: 'Ready for Collection' },
    { value: 'out_for_delivery', label: 'Out for Delivery' },
    { value: 'delivered', label: 'Delivered' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'refunded', label: 'Refunded' }
  ];

  const handleStatusChange = (status: OrderStatus, checked: boolean) => {
    const currentStatuses = filters.status || [];
    const newStatuses = checked
      ? [...currentStatuses, status]
      : currentStatuses.filter(s => s !== status);
    
    onFiltersChange({
      ...filters,
      status: newStatuses.length > 0 ? newStatuses : undefined
    });
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFiltersChange({
      ...filters,
      search: e.target.value || undefined
    });
  };

  const clearFilters = () => {
    onFiltersChange({});
  };

  const hasActiveFilters = filters.status?.length || filters.search;

  return (
    <div className={`order-filters ${className}`}>
      <div className="filters-header">
        <h3>Filters</h3>
        {hasActiveFilters && (
          <button 
            className="clear-filters-btn"
            onClick={clearFilters}
          >
            Clear All
          </button>
        )}
      </div>

      <div className="filters-content">
        {/* Search */}
        <div className="filter-group">
          <label className="filter-label">Search</label>
          <input
            type="text"
            placeholder="Search orders, customers..."
            value={filters.search || ''}
            onChange={handleSearchChange}
            className="search-input"
          />
        </div>

        {/* Order Status */}
        <div className="filter-group">
          <label className="filter-label">Order Status</label>
          <div className="checkbox-group">
            {orderStatusOptions.map(option => (
              <label key={option.value} className="checkbox-label">
                <input
                  type="checkbox"
                  checked={filters.status?.includes(option.value as OrderStatus) || false}
                  onChange={(e) => handleStatusChange(option.value as OrderStatus, e.target.checked)}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default OrderFilters;
